module.exports = __webpack_public_path__ + "img/itemico1.06898bbf.png";